import styled from "styled-components";

export const Wrapper = styled.div`
    background-color: ${(props) => (props.color ? props.color : "transparent")};
    border-radius: 0px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    color: ${globalThis.config.colors.black};
    font-size: ${globalThis.config.fonts.sizes.small};
`;

export const PillBorder = styled.button`
    background-color: transparent;
    margin: 0px;
    padding: 0px;
    width: 100%;
    height: 100%;
    color: ${globalThis.config.colors.black};
    font-size: ${globalThis.config.fonts.sizes.small};
    cursor: pointer;
    border: 1px solid;
    border-color: ${(props) =>
        props.selected
            ? `${globalThis.config.colors.black} !important`
            : globalThis.config.colors.white};
    &:hover {
        border-color: ${globalThis.config.colors.gray5};
    }
`;

export const Pipe = styled.div`
    width: 0.05rem;
    height: 0.45rem;
    background-color: ${globalThis.config.colors.black};
`;

export const AllocatedHours = styled.div`
    font-family: ${globalThis.config.fonts.families.bold};
    text-align: right;
    padding: 0.325rem;
    width: 50%;
    height: 100%;
`;

export const AvailableHours = styled.div`
    text-align: left;
    padding: 0.325rem;
    width: 50%;
    height: 100%;
    font-family: ${globalThis.config.fonts.families.light};
`;

export const NotAvailableAllocation = styled.div`
    font-family: ${globalThis.config.fonts.families.bold};
    text-align: center;
    width: 100%;
    height: 100%;
    padding: 0.325rem;
`;
